import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type ArrowLeftIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = ({ width = 12, height = 12, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_8402_122324)">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.20718 5.50004L5.35363 2.35359L4.64652 1.64648L0.646522 5.64648L0.292969 6.00004L0.646522 6.35359L4.64652 10.3536L5.35363 9.64648L2.20718 6.50004H12.0001V5.50004H2.20718Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_8402_122324">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconSpan>
);
